module.exports = __webpack_public_path__ + "static/img/item-ywlc.4cb17663.png";